import { cn } from "@/lib/utils";

/** Stylistic "Orange" wordmark — display type + brand gradient (not body UI text). */
export function BrandLogotype({
  className,
  /** `on-dark` = pine sidebar / teal panels; default adapts to light vs dark theme. */
  tone = "default",
}: {
  className?: string;
  tone?: "default" | "on-dark";
}) {
  return (
    <span
      className={cn(
        "brand-logotype inline-block select-none",
        tone === "on-dark" && "brand-logotype-on-dark",
        className,
      )}
    >
      Orange
    </span>
  );
}
